exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-62781b04] {\n  margin-right: 0;\n}", ""]);

// exports
